import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as usg_action from 'actions/usage';
import { Grid, Menu } from 'semantic-ui-react';
import { BillGroupDetail, BillGroupList, BillSearchForm, BillApprovalStep } from 'components/Bill';
import { LoadingBar } from 'components/Commons';
import cm from 'helpers/commons';
import toastr from 'helpers/toastr';
import storage from 'helpers/storage';
import _ from 'helpers/_';
import moment from 'moment-timezone';
moment.tz.setDefault('Asia/Seoul');

const propTypes = {};
const defaultProps = {};

class Bill extends Component {
  constructor(props) {
    super(props);
    // const auth = storage.get('info').auth.auth;
    const auth = cm.authGroupSet('invoice:view');
    this.state = {
      activeItem: 'bill',
      param: {
        keyword: null,
        orgCode: null,
        groupid: null,
        viewType: 'all'
      },
      accountIdx: null,
      pIdx: null,
      isLoadingBar: false,
      params: null,
      billDtlIndex: 0,
      open: false,
      btnName: null,
      stepNumber: null,
      yyyy: moment(new Date()).format('YYYY'),
      mmdd: null,
      groupIdx: null,
      groupName: null,
      isAuth: cm.isEmpty(auth) ? false : true
    };
  }

  async componentWillMount() {
    let comInfo = (storage.get('company') || {}).info;

    if (!(comInfo || {}).isInvoice) {
      this.context.router.history.push('/service/landing');
      return;
    }
    const { state } = this.context.router.route.location;
    const pInvoiced = cm.getQuerystring('invoiced');
    const pAccount = Number(cm.getQuerystring('account'));
    let invoiced = pInvoiced ? pInvoiced : null;
    let account = pAccount ? pAccount : null;
    if (state || (invoiced && account)) {
      if (state) {
        invoiced = state.invoiced;
        account = state.account;
      }
      let yyyy = moment(new Date(invoiced)).format('YYYY');
      let mmdd = moment(new Date(invoiced)).format('MM-DD');
      const params = {
        yyyy,
        mmdd,
        account
      };
      this.setState({
        isLink: true,
        yyyy,
        mmdd,
        params
      });
      this.billDtl(account, params, true);
    }
  }

  componentDidMount() {
    cm.mainTitle('청구서 관리');
  }

  onOpenModal = (btnName, stepNumber) => {
    console.log(btnName);
    console.log(stepNumber);
    if (btnName) {
      this.setState({
        open: true,
        btnName: btnName,
        stepNumber: stepNumber
      });
    }
  };

  onCloseModal = () => {
    const { billDtlIndex } = this.props;

    if (billDtlIndex !== 0) {
      this.setState({ billDtlIndex: 0 });
    }

    this.setState({ open: false });
  };

  // 반려된 청구서 목록 조회
  getRejectInvoices = (idx) => {
    this.setState({
      billDtlIndex: idx
    });
  };

  loadingBarState = (state) => {
    this.setState({ isLoadingBar: state });
  };

  isGroupAdmin = (pIdx) => {
    const { accountChildrens } = this.state;
    const isAccount = _.find(accountChildrens, (ac) => ac.billingAccountIdx === pIdx);
    if (isAccount) this.setState({ groupAdminBtn: true });
    else this.setState({ groupAdminBtn: false });
  };

  //일별 식대 청구내역 조회
  billDtl = async (pIdx, params, isLink, name) => {
    const { usageAPI } = this.props;
    const { invoiceIdx, isLoadingBar } = this.state;
    const idx = pIdx ? pIdx : invoiceIdx;
    const invoiced = moment(`${params.yyyy}-${params.mmdd}`).format('LL');
    const param = { invoiced: invoiced };
    if (!isLoadingBar) {
      this.loadingBarState(true);
    }
    try {
      await usageAPI.billDtl(idx, param);
      this.isGroupAdmin(pIdx);
      this.setState({
        pIdx: pIdx,
        invoiceIdx: null,
        groupIdx: idx,
        groupName: name,
        mmdd: moment(new Date(invoiced)).format('MM-DD')
      });
      if (isLink) {
        const { billDtl } = this.props;
        if (billDtl && billDtl.data) {
          const { invoiced } = billDtl.data;
          this.billGroupListSel(params, null, true);
        }
      }
    } catch (error) {
      if (error.response && error.response.data) {
        const { message } = error.response.data;
        toastr('top-right', 'error', message);
        setTimeout(() => {
          this.context.router.history.push('/service/landing');
        }, 500);
      }
      return;
    } finally {
      this.loadingBarState(false);
    }
  };

  //청구목록 그룹,계좌 조회
  billGroupListSel = async (params, pIdx, isNotCall) => {
    const { activeItem, isLoadingBar } = this.state;
    const { usageAPI } = this.props;
    const isBill = activeItem === 'bill';
    const invoiced = isBill ? moment(`${params.yyyy}-${params.mmdd}`).format('LL') : null;
    const param = { invoiced: invoiced };
    if (!isLoadingBar) {
      this.loadingBarState(true);
    }
    try {
      await this.setState({ params: params });
      await usageAPI.billGroupListSel(param);

      const { billGroupList } = this.props;
      if (billGroupList && billGroupList.data) {
        const { accounts } = billGroupList.data;
        // console.log('accounts ', accounts[0].billingAccountIdx, accounts);
        let accountIdx = pIdx ? pIdx : accounts[0].billingAccountIdx;
        accountIdx = accountIdx || 0;
        let accountChildrens = [];
        let temp;
        accounts.forEach((item) => {
          if (item.containsMe && item.accountChildrens) {
            temp = accountChildrens.concat(item.accountChildrens);
            accountChildrens = temp;
          }
        });

        await this.setState({
          accountIdx: accountIdx,
          groupIdx: accountIdx,
          accountChildrens: accountChildrens
        });

        if (!isNotCall && isBill) {
          this.billDtl(accountIdx, params, false);
        }
      }
    } catch (error) {
      if (error.response && error.response.data) {
        const { message } = error.response.data;
        toastr('top-right', 'error', message);
      } else {
        console.log('##### error: ', error);
      }
    } finally {
      this.loadingBarState(false);
    }
  };

  // 청구서 승인
  billAccepted = async (pMethod, id, iIdx, stepNumber) => {
    const { usageAPI } = this.props;
    const { pIdx, params } = this.state;
    const method = pMethod;
    const data = {
      userId: id,
      stepNumber
    };

    try {
      await this.setState({ invoiceIdx: pIdx });
      await usageAPI.billAccepted(method, data, pIdx, iIdx);
      await this.billGroupListSel(params, pIdx);

      this.setState({ open: false });
    } catch (error) {
      if (error.response && error.response.data) {
        const { message } = error.response.data;
        toastr('top-right', 'error', message);
      } else {
        console.log('##### error: ', error);
      }
    }
  };

  // 청구서 반려
  billRejected = async (id, cause, iIdx, stepNumber) => {
    const { usageAPI } = this.props;
    const { pIdx, params } = this.state;
    const data = {
      userId: id,
      stepNumber,
      cause
    };

    try {
      await this.setState({ invoiceIdx: pIdx });
      await usageAPI.billRejected(data, pIdx, iIdx);
      await this.billGroupListSel(params, pIdx);

      this.setState({ open: false });
    } catch (error) {
      if (error.response && error.response.data) {
        const { message } = error.response.data;
        toastr('top-right', 'error', message);
      } else {
        console.log('##### error: ', error);
      }
    }
  };

  billParentRejected = async (cause, iIdx, stepNumber) => {
    const { usageAPI } = this.props;
    const { pIdx, params } = this.state;
    const data = {
      stepNumber,
      cause
    };

    try {
      console.log(stepNumber);
      console.log(iIdx);
      await this.setState({ invoiceIdx: pIdx });
      await usageAPI.billParentRejected(data, pIdx, iIdx);
      await this.billGroupListSel(params, pIdx);

      this.setState({ open: false });
    } catch (error) {
      if (error.response && error.response.data) {
        const { message } = error.response.data;
        toastr('top-right', 'error', message);
      } else {
        console.log('##### error: ', error);
      }
    }
  };

  // 청구서 재발행
  billReturn = async (iIdx, step) => {
    const { usageAPI } = this.props;
    const { pIdx } = this.state;
    const isCon = confirm('재발행을 하시겠습니까?');
    if (!isCon) return;

    try {
      const data = {
        step
      };
      await usageAPI.billReturn(data, pIdx, iIdx);
      alert('재발행된 청구서는 1분후 생성됩니다.');
    } catch (error) {
      if (error.response && error.response.data) {
        const { message } = error.response.data;
        toastr('top-right', 'error', message);
      } else {
        console.log('##### bill Return error', error);
      }
    }
  };

  //청구서 상세 리스트 조회
  billDetListSel = async (iIdx, params) => {
    const { usageAPI } = this.props;
    try {
      await usageAPI.billDetListSel(iIdx, params);
    } catch (error) {
      if (error.response && error.response.data) {
        const { message } = error.response.data;
        toastr('top-right', 'error', message);
      } else {
        console.log('##### error: ', error);
      }
      this.setState({ open: false });
    }
  };

  //청구서 상세 total
  billDetTotalSel = async (iIdx) => {
    const { usageAPI } = this.props;
    try {
      await usageAPI.billDetTotalSel(iIdx);
    } catch (error) {
      if (error.response && error.response.data) {
        const { message } = error.response.data;
        toastr('top-right', 'error', message);
      } else {
        console.log('##### error: ', error);
      }
      this.setState({ open: false });
    }
  };

  /**
   * 청구서 결재라인
   */

  // top menu 클릭
  handleMenuClick = async (e, { name }) => {
    await this.setState({
      activeItem: name,
      invoiceIdx: this.state.pIdx
    });
    if (name === 'billApproval') {
      this.billGroupListSel(null, this.state.groupIdx, true);
    } else {
      this.loadingBarState(true);
    }
  };

  ApprovalStepGroupIdx = (idx, name) => {
    this.setState({
      groupIdx: idx,
      pIdx: idx,
      groupName: name
    });
  };

  // 결재라인 상세
  billApprovalStepSel = async (idx) => {
    const { usageAPI } = this.props;
    try {
      await usageAPI.approvalStepSel(idx, null);
    } catch (error) {
      console.log('##### approvalStepSel error: ', error);
    }
  };

  render() {
    const {
      billRejected,
      billParentRejected,
      billAccepted,
      onOpenModal,
      billDetListSel,
      billDetTotalSel,
      billReturn
    } = this;
    const { billDtl, billGroupList } = this.props;
    const {
      searchDate,
      isLoadingBar,
      params,
      billDtlIndex,
      open,
      btnName,
      stepNumber,
      isLink,
      yyyy,
      mmdd,
      invoiceIdx,
      activeItem,
      groupIdx,
      groupName,
      isAuth,
      accountChildrens,
      groupAdminBtn
    } = this.state;
    const modalFn = {
      open: open,
      btnName: btnName,
      stepNumber: stepNumber,
      close: this.onCloseModal,
      getRejectInvoices: this.getRejectInvoices,
      billAccepted: this.billAccepted,
      billRejected: this.billRejected,
      billParentRejected: this.billParentRejected
    };
    return (
      <main className="bill">
        {isLoadingBar ? <LoadingBar /> : null}
        <Menu fluid widths={2} className={isAuth ? 'vendysFullTab' : null} tabular>
          <Menu.Item active={activeItem === 'bill'} name="bill" onClick={isAuth ? this.handleMenuClick : null}>
            <span>청구서</span>
          </Menu.Item>
          {isAuth ? (
            <Menu.Item active={activeItem === 'billApproval'} name="billApproval" onClick={this.handleMenuClick}>
              <span>청구서 결재라인</span>
            </Menu.Item>
          ) : (
            <Menu.Item disabled></Menu.Item>
          )}
        </Menu>
        {activeItem === 'bill' ? (
          <BillSearchForm
            searchDate={searchDate}
            invoiceIdx={invoiceIdx}
            billGroupListSel={this.billGroupListSel}
            isLink={isLink}
            yyyy={yyyy}
            mmdd={mmdd}
          />
        ) : null}
        {billGroupList && billGroupList.data ? (
          <Grid style={{ padding: '1rem 1rem 0 1rem' }}>
            <Grid.Column width={4} style={{ padding: 0 }}>
              {billGroupList &&
              billGroupList.data &&
              billGroupList.data.accounts &&
              billGroupList.data.accounts.length > 0 ? (
                <BillGroupList
                  billDtl={this.billDtl}
                  billApprovalStepSel={this.billApprovalStepSel}
                  ApprovalStepGroupIdx={this.ApprovalStepGroupIdx}
                  billGroupList={billGroupList.data.accounts}
                  params={params}
                  isLink={isLink}
                  invoiceIdx={invoiceIdx}
                  activeItem={activeItem}
                />
              ) : null}
            </Grid.Column>
            {activeItem === 'bill' ? (
              <Grid.Column width={12} style={{ padding: 0 }}>
                <BillGroupDetail
                  billDtl={billDtl}
                  billDtlIndex={billDtlIndex}
                  billDetListSel={billDetListSel}
                  billDetTotalSel={billDetTotalSel}
                  modalFn={modalFn}
                  billRejected={billRejected}
                  billParentRejected={billParentRejected}
                  billAccepted={billAccepted}
                  onOpenModal={onOpenModal}
                  invoiceIdx={invoiceIdx}
                  groupAdminBtn={groupAdminBtn}
                  billReturn={billReturn}
                />
              </Grid.Column>
            ) : (
              <Grid.Column width={12} style={{ padding: 0 }}>
                <BillApprovalStep
                  invoiceIdx={invoiceIdx}
                  groupIdx={groupIdx}
                  groupName={groupName}
                  billGroupListSel={this.billGroupListSel}
                  loadingBarState={this.loadingBarState}
                />
              </Grid.Column>
            )}
          </Grid>
        ) : null //<LoadingBar />
        }
      </main>
    );
  }
}

Bill.propTypes = propTypes;
Bill.defaultProps = defaultProps;

Bill.contextTypes = {
  router: PropTypes.object.isRequired
};

Bill = connect(
  (state) => ({
    billDtl: state.usage.billDtl,
    billGroupList: state.usage.billGroupList,
    staffDivisionList: state.commons.staffDivision
  }),
  (dispatch) => ({
    usageAPI: bindActionCreators(
      {
        billDtl: usg_action.BillDtl,
        billGroupListSel: usg_action.BillGroupList,
        billAccepted: usg_action.BillAccepted,
        billRejected: usg_action.BillRejected,
        billParentRejected: usg_action.BillParentRejected,
        billReturn: usg_action.BillReturn,
        billDetListSel: usg_action.BillDetList,
        billDetTotalSel: usg_action.BillDetTotal,
        approvalStepSel: usg_action.BillApprovalStepList
      },
      dispatch
    )
  })
)(Bill);

export default Bill;
